module.exports = __webpack_public_path__ + "static/media/icon-medidor-blue.c52649c9.svg";